import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  {
    // tika首页介绍
    path: "/tika/activity/kindkey",
    name: "tikaKinkkey",
    component: () =>
      import(
        /* webpackChunkName: "tikaKinkkey" */ "@/views/tika/activity/KindKey.vue"
      ),
    meta: {
      cname: "亲情钥匙",
    },
  },
  {
    // 本田宣发钥匙安装视频说明书
    path: "/tika/share",
    name: "tikaShare",
    component: () =>
      import(
        /* webpackChunkName: "tikaShare" */ "@/views/tika/activity/sharekey.vue"
      ),
    meta: {
      cname: "钥匙分享",
    },
  },
  {
    // tika首页介绍
    path: "/tika/home-intro",
    name: "tikaHomeIntro",
    component: () =>
      import(
        /* webpackChunkName: "tikaHomeIntro" */ "@/views/tika/HomeIntro.vue"
      ),
    meta: {
      cname: "绑车",
    },
  },
  {
    // 海外常见问题
    path: "/tika/commonProblems",
    name: "tikaCommonProblems",
    component: () =>
      import(
        /* webpackChunkName: "tikaCommonProblems" */ "@/views/tika/help-center/HelpCenter.vue"
      ),
    meta: {
      cname: "帮助中心",
    },
  },
  {
    path: "/tika/feedback",
    name: "tikaFeedback",
    component: () =>
      import(
        /* webpackChunkName: "tikaFeedback" */ "@/views/tika/feedback/Feedback.vue"
      ),
    meta: {
      cname: "意见反馈",
    },
  },
  {
    path: "/tika/feedback-success",
    name: "tikaFeedbackSuccess",
    component: () =>
      import(
        /* webpackChunkName: "tikaFeedbackSuccess" */ "@/views/tika/feedback/FeedbackSuccess.vue"
      ),
    meta: {
      cname: "反馈成功",
    },
  },
  {
    // 裂变首页
    path: "/tika/invite-home",
    name: "tikaInviteHome",
    component: () =>
      import(
        /* webpackChunkName: "tikaInviteHome" */ "@/views/tika/invite/InviteHome.vue"
      ),
    meta: {
      cname: "邀请好友",
    },
  },
  {
    // 裂变详情
    path: "/tika/invite-detail",
    name: "tikaInviteDetail",
    component: () =>
      import(
        /* webpackChunkName: "tikaInviteDetail" */ "@/views/tika/invite/InviteDetail.vue"
      ),
    meta: {
      cname: "邀请好友",
    },
  },
  {
    // 裂变核销
    path: "/tika/invite-verify",
    name: "tikaInviteVerify",
    component: () =>
      import(
        /* webpackChunkName: "tikaInviteVerify" */ "@/views/tika/invite/InviteVerify.vue"
      ),
    meta: {
      cname: "邀请好友",
    },
  },
    {
    path: '/tika/sm',
    name: 'smTikaDetail',
    component: () => import(/* webpackChunkName: "smTikaDetail" */ '@/views/tika/support-model/IndexView.vue'),
    meta: {
      cname: '支持的车型'
    }
  },
  {
    path: '/tika/sm/detail',
    name: 'smTikaDetailView',
    component: () => import(/* webpackChunkName: "smTikaDetailView" */ '@/views/tika/support-model/DetailView.vue'),
    meta: {
      cname: '安装说明'
    }
  },
  {
    path: '/tika/sm/search',
    name: 'smTikaSearch ',
    component: () => import(/* webpackChunkName: "smTikaSearch" */ '@/views/tika/support-model/SearchView.vue'),
    meta: {
      cname: '数字鑰匙查询'
    }
  },
  {
    path: '/tika/sm/pdf',
    name: 'smTikaPdf',
    component: () => import(/* webpackChunkName: "smTikaPdf" */ '@/views/tika/support-model/PdfView.vue'),
    meta: {
      cname: '查看说明书'
    }
  },
  {
    path: '/tika/sm/video',
    name: 'smTikaVideo',
    component: () => import(/* webpackChunkName: "smTikaVideo" */ '@/views/tika/support-model/VideoView.vue'),
    meta: {
      cname: '查看视频'
    }
  },
  {
    // 夏日清凉活动
    path: '/tika/activity/summer-cool',
    name: 'tikaSummerCool',
    component: () =>
      import(/* webpackChunkName: "tikaSummerCool" */ '@/views/tika/activity/SummerCool.vue'),
    meta: {
      cname: '夏日清凉'
    }
  }
];
export default routes;
